import React from 'react';

type Variant = 'pipeline' | 'inbound';

const copy: Record<
  Variant,
  { title: string; bullets: { strong: string; text: string }[] }
> = {
  pipeline: {
    title: 'How pipeline leads work',
    bullets: [
      {
        strong: 'Hot, warm, cold',
        text: 'Your quick priority signal—work hot leads first when time is tight.',
      },
      {
        strong: 'Score (0–100)',
        text: 'Combines fit, source, and recent activity. Use it to break ties between similar leads.',
      },
      {
        strong: 'Status',
        text: 'Tracks outreach steps (new → contacted → replied, etc.). When qualified, convert to a prospect.',
      },
    ],
  },
  inbound: {
    title: 'How inbound leads work',
    bullets: [
      {
        strong: 'Source',
        text: 'Shows where the inquiry came from (website, referral, etc.).',
      },
      {
        strong: 'Score & priority',
        text: 'Helps you decide who to contact first. Higher scores usually mean stronger intent or fit.',
      },
      {
        strong: 'Convert',
        text: 'When someone is qualified, convert them into a pipeline contact or prospect.',
      },
    ],
  },
};

const PipelineFieldHints: React.FC<{ variant: Variant }> = ({ variant }) => {
  const c = copy[variant];
  return (
    <div
      className="rounded-xl border border-border bg-surface px-4 py-3 text-sm text-fg-secondary shadow-sm"
      role="note"
    >
      <p className="font-medium text-fg">{c.title}</p>
      <ul className="mt-2 space-y-1.5 text-xs sm:text-sm list-none">
        {c.bullets.map((b) => (
          <li key={b.strong} className="flex gap-2">
            <span className="text-primary shrink-0" aria-hidden>
              •
            </span>
            <span>
              <span className="font-medium text-fg">{b.strong}</span>
              {' — '}
              {b.text}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PipelineFieldHints;
